(function () {
  if (window.__earlyAccessLoginInit) return;
  window.__earlyAccessLoginInit = true;

  function isIndiaVisitor() {
    var country = String(
      (window.Shopify && window.Shopify.country) || "",
    ).toUpperCase();
    if (country) return country === "IN";
    return new Date().getTimezoneOffset() === -330;
  }

  function redirectToShopifyLogin() {
    var returnTo = encodeURIComponent(
      window.location.pathname + window.location.search,
    );
    var locale = encodeURIComponent(
      (window.Shopify && window.Shopify.locale) || "en",
    );
    window.location.href =
      "/customer_authentication/login?return_to=" +
      returnTo +
      "&locale=" +
      locale;
  }

  document.addEventListener(
    "click",
    function (event) {
      var trigger =
        event.target instanceof Element
          ? event.target.closest("[data-early-access-login]")
          : null;
      if (!trigger) return;

      if (isIndiaVisitor()) {
        if (typeof window.handleKpAndShopifyLogin === "function") {
          window.handleKpAndShopifyLogin();
          return;
        }
        if (typeof window.kpHandleLogin === "function") {
          window.kpHandleLogin();
          return;
        }
      }

      redirectToShopifyLogin();
    },
    true,
  );

  document.addEventListener("kp-data-sent", function () {
    window.setTimeout(function () {
      window.location.reload();
    }, 1000);
  });
})();
